export const isVestel2017 =
  typeof window !== 'undefined' &&
  /vestel.+2017/i.test(window.navigator.userAgent);
